import { MapPin } from "lucide-react";
import { env } from "@/lib/env";

interface MapViewProps {
  lat: number;
  lng: number;
  updatedAt: string;
}

/**
 * Map placeholder. When VITE_MAPBOX_TOKEN is set, swap this for a real Mapbox GL
 * map (lazy-import mapbox-gl here so the public bundle stays light). The token is
 * URL-restricted in the Mapbox dashboard, so it is safe as a VITE_ var.
 */
export function MapView({ lat, lng, updatedAt }: MapViewProps) {
  const configured = Boolean(env.mapboxToken);
  return (
    <div className="relative grid h-64 place-items-center overflow-hidden rounded-lg border border-brand-100 bg-brand-50">
      <div className="text-center">
        <MapPin className="mx-auto h-8 w-8 text-accent-500" />
        <p className="mt-2 text-sm font-medium text-brand-800">
          {lat.toFixed(3)}, {lng.toFixed(3)}
        </p>
        <p className="text-xs text-brand-500">
          Updated {new Date(updatedAt).toLocaleString()}
        </p>
        {!configured && (
          <p className="mt-2 text-xs text-brand-400">
            (Map renders once VITE_MAPBOX_TOKEN is set)
          </p>
        )}
      </div>
    </div>
  );
}
